import PropTypes from 'prop-types'
import React, {PureComponent} from 'react'
import CSSModules from 'react-css-modules'
import Isvg from 'react-inlinesvg'

import SecondaryTitle from 'components/title_secondary/title_secondary'
import LessonCodesList from 'components/lesson_codes_list/lesson_codes_list'
import { BaseButton, SecondaryButton } from 'components/button'
import { localize } from 'helpers/translator'

import styles from './my_library_launch_session.scss'

class LessonCodesLaunchSession extends PureComponent {

	constructor() {
		super()
		this.state = {
			selectedSessionUid: '',
		}
		this.handleOnChangeSessionUid = this.handleOnChangeSessionUid.bind(this)
		this.handleSelectAction = this.handleSelectAction.bind(this)
	}

	handleOnChangeSessionUid(sessionUid) {
		this.setState({
			selectedSessionUid: sessionUid,
		})
	}

	handleSelectAction() {
		const currentCode = this.props.codes.find( code => code.session_uid === this.state.selectedSessionUid )
		this.props.handleSelectedCode(currentCode)
	}

	handleShareAction = () => {
		const currentCode = this.props.codes.find( code => code.session_uid === this.state.selectedSessionUid )
		this.props.handleShareAction(currentCode)
	}

	render() {
		return (
			<div styleName='wrapper'>
				<h3 styleName='title'>{localize('my_library_launch_session_title')}</h3>
				<div styleName='btn-launch'>
					<BaseButton bgColor='blue' fontColor='white' onClick={this.props.handleLaunchNew}>
						<Isvg src={this.props.icon} cacheGetRequests={true} styleName='icon' />
						{this.props.launchNewText}
					</BaseButton>
				</div>
				<SecondaryTitle isCentered={true}>{this.props.subtitle}</SecondaryTitle>
				<LessonCodesList
					actualTimestamp={this.props.actualTimestamp}
					isSelectable={true}
					dateTitle={localize('my_library_launch_session_date_title')}
					codeTitle={localize('my_library_launch_session_code_title')}
					expirationTitle={localize('my_library_launch_session_expire_title')}
					codes={this.props.codes}
					dateText={localize('my_library_launch_session_date_text')}
					canChangeExpirationDate={this.props.canChangeExpirationDate}
					handleSaveExpirationDate={this.props.handleSaveExpirationDate}
					handleOnChangeSessionUid={this.handleOnChangeSessionUid}
				/>
				<div styleName='btn-container'>
					<div styleName='btn-cancel'>
						<BaseButton bgColor='blue' fontColor='white' onClick={this.props.handleCancelAction}>{localize('global_cancel')}</BaseButton>
					</div>
					{this.props.canResume &&
						<div styleName='btn-resume'>
							<SecondaryButton onClick={this.handleSelectAction} disabled={!this.state.selectedSessionUid}>
								{this.props.buttonText}
							</SecondaryButton>
						</div>
					}
					{this.props.canShare &&
						<div styleName='btn-resume'>
							<SecondaryButton onClick={this.handleShareAction} disabled={!this.state.selectedSessionUid}>
								{localize('my_library_launch_student_paced_share')}
							</SecondaryButton>
						</div>
					}
				</div>
			</div>
		)
	}
}

LessonCodesLaunchSession.propTypes = {
	launchNewText: PropTypes.string,
	buttonText: PropTypes.string,
	subtitle: PropTypes.string,
	canChangeExpirationDate: PropTypes.bool,
	handleClickAction: PropTypes.func,
	handleSaveExpirationDate: PropTypes.func,
	actualTimestamp: PropTypes.number,
	canShare: PropTypes.bool,
	canResume: PropTypes.bool,
}

LessonCodesLaunchSession.defaultProps = {
	canChangeExpirationDate: false,
	subtitle: '',
	handleSaveExpirationDate: () => {},
	actualTimestamp: 0,
	canShare: false,
	canResume: true,
}

export default (CSSModules(LessonCodesLaunchSession, styles, {allowMultiple: true}))
